import React from "react";
import PropTypes from "prop-types";
import styles from "./InfoText.module.scss";

const InfoText = props => {
  return (
    <>
      <div className={`${styles["info-container"]} ${props.className}`}>
        <p className={`${styles["info-text"]}`}>{props.text}</p>
      </div>
    </>
  );
};

InfoText.defaultProps = {
  className: "",
  text: "Prepaid only"
};
InfoText.propTypes = {
  className: PropTypes.string,
  text: PropTypes.string
};
export default InfoText;
